export const API_URL = 'https://scherp-api.securebit.eu/api';
export const BASE_URL = 'https://scherp-api.securebit.eu';

export const ANONYMOUS_TOKEN = 'f6ec183c84c4a7a2382acc11a2cb58e26b53cc1f'